import WalletPaymentConfirm from '../../../../components/alertPopup/WalletPaymentConfirm';
import { Box, Checkbox, List, ListItem, Typography } from "../../../../imports/muiImport";
import { useState, useSelector } from "../../../../imports/generalImport";
import { useEffect } from 'react';


function PayFromWallet({ walletPayment, setWalletPayment }) {
  const [netPay, setNetPay] = useState(0);
  const [walletPayConfirm, setWalletPayConfirm] = useState(false);

  let userProfile = useSelector((state) => state.UserProfile?.allData?.data);
  const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const balance = useSelector((state) => state.UserBalance?.allData);
  const calculateNetPay = (items) => items.reduce((acc, item) => acc + item.TOTAL, 0);
  const TOTAL_DISCOUNT = (total, dis) => total / 100 * dis;
  const userBalanceStore = useSelector((state) => state?.UserProfile?.allData);

  const walletAmount = Number(userBalanceStore?.walletDatum?.amount || 0);
  useEffect(() => {
    if (DENOMINATION_STORE_DATA?.length > 0) {
      const total = calculateNetPay(DENOMINATION_STORE_DATA);
      const finalPay = TOTAL_DISCOUNT(total, DENOMINATION_STORE_DATA?.[0]?.DISCOUNT);
      let np;
      let bal;

      if (PRODUCTDETAILS.isCashbackProduct) {
        np = total;
        bal = balance;
      } else {
        np = total - finalPay;
        bal = balance;
      }


      if (bal >= np) {
        setNetPay(np)
      } else {
        setNetPay(bal);
      }
    } else {
      setNetPay(0);
    }
  }, [DENOMINATION_STORE_DATA]);

  const handleWalletPayConfirmOpen = () => {
    setWalletPayConfirm(true);
  };

  const handleWalletPayConfirmClose = () => {
    setWalletPayConfirm(false);
  };

  return (
    <>
      <Box
        sx=
        {{
          mt: { xs: 2, lg: 2 },
          width: "100%",
          display: "flex",
          justifyContent: "center",

        }}>
        <Box
          sx=
          {{
            borderRadius: "10px",
            minHeight: "30px",
            border: "1px solid #E4C18F",
            width: "100%",
            maxWidth: { xs: "100%", md: "550px", lg: "650px" },
          }}>
          <List sx={{ py: 0 }}>
            <ListItem sx={{ justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Typography variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: { xs: 500, md: 600 },
                    fontSize: { xs: "13.5px", sm: "13px ", md: "14px", lg: '16px' },
                    fontFamily: "Be Vietnam Pro",
                    px: { xs: 0, sm: 1 },

                  }}>
                  Wallet Amount
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "textPrimary.main",
                    fontWeight: 500,
                    fontSize: {
                      xs: "1rem",
                      sm: "16px"
                    },
                    fontFamily: "Be Vietnam Pro"
                  }}
                >
                  AED {Number(userBalanceStore?.walletDatum?.amount || 0).toFixed(2)}
                </Typography>

                <Checkbox
                  checked={walletPayment}
                  disabled={walletAmount <= 0}
                  onChange={(e) => setWalletPayment(e.target.checked)}
                  sx={{
                    "&.Mui-checked": {
                      color: "#0fab22",
                    },
                    "&.Mui-disabled": {
                      color: "#BDBDBD",
                    },
                    "&.Mui-checked.Mui-disabled": {
                      color: "#BDBDBD",
                    },
                  }}
                />
              </Box>

            </ListItem>

          </List>

        </Box>
      </Box>

      <WalletPaymentConfirm
        walletPayConfirmTitle={'Pay from Your Wallet'}
        walletPayConfirmContent={walletPaymentConfirmation(userProfile, netPay)}
        open={walletPayConfirm}
        handleWalletPayConfirmOpen={handleWalletPayConfirmOpen}
        handleWalletPayConfirmClose={handleWalletPayConfirmClose}
        setWalletPayment={setWalletPayment}
      />
    </>
  );


  function walletPaymentConfirmation(userProfile, totalPayout) {
    return (<Typography
      variant="subtitle1"
      sx={{
        color: "dark.main2",
        fontSize: "18px",
        textTransform: "capitalize",
        fontWeight: { xs: 700, sm: 700, lg: 700 },
        textAlign: "center"
      }}>
      Are you sure you want to deduct
      <Typography component="span" sx={{ color: "dark.main", fontWeight: 500, fontSize: "18px", px: 1, }}>
        AED{
          totalPayout > userProfile?.['balance'] ?
            userProfile?.['balance']
            :
            totalPayout
        }
      </Typography>
      amount from your wallet ?
    </Typography>);
  }

}

export default PayFromWallet;
